export default __webpack_public_path__ + "static/media/elle4.86693ce6.webp";